import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFirestore, doc, setDoc, updateDoc } from "firebase/firestore";

const DropboxCallback: React.FC = () => {
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const params = new URLSearchParams(window.location.hash.substring(1));
  const accessToken = params.get("access_token");
  const navigate = useNavigate();

  useEffect(() => {
    // const sync = async () => {
    //   if (!accessToken) {
    //     setError("No access token provided");
    //     return;
    //   }
    //   setSyncing(true);
    //   const db = getFirestore();
    //   await setDoc(
    //     doc(db, "accounts", account._id, "integrations", "dropbox"),
    //     {
    //       accessToken,
    //     },
    //     { merge: true },
    //   );
    //   setSyncing(false);
    //   navigate("/settings/integrations");
    // };
    // sync();
  }, []);

  return <div>Authorizing Dropbox...</div>;
};

export default DropboxCallback;
